<template>
<v-dialog :max-width="$store.getters['View/isMobile'] ? '90vw' : '60vw'" class="register-dialog" :value="getRegisterShow" persistent>
  <v-card class="elevation-12">
    <router-view />
  </v-card>
</v-dialog>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  computed: {
    ...mapGetters('View', [
      'getRegisterShow'
    ])
  },
  methods: {
    ...mapActions('View', [
      'setRegisterShow'
    ])
  },
  created(){
    this.setRegisterShow(true);
  }
}
</script>
